import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { BannerComponent } from './banner/banner.component';
import { HomepageComponent } from './homepage.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { SharedModule } from 'src/app/shared/shared.module';

const HOME_ROUTE = [
  {path: "", component: HomepageComponent},
  // {path: "offers/:category", component: HomepageComponent},
  // {path: "offers/:category/:sub_category", component: HomepageComponent},

];
@NgModule({
  declarations: [
  	BannerComponent,
    HomepageComponent
  ],
  imports: [
    CommonModule,
    CarouselModule.forRoot(),
    RouterModule.forChild(HOME_ROUTE),
    SharedModule
  ],
  exports: [
  	BannerComponent
  ]
})
export class HomepageModule { }
